import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";

import ModalContainer from "./ModalContainer";

class MyScheduleAnnouncementModal extends Component {
    render() {
        return (
            <ModalContainer
                open={this.props.open}
                title="Introducing My Schedule"
                onClose={this.props.onDismiss}
                fullScreen={false}
                maxWidth="sm"
            >
                <DialogContent>
                    <DialogContentText component="div">
                        <Typography paragraph>
                            We've combined your Dashboard and My Gigs into one streamlined experience called <strong>My Schedule</strong>.
                        </Typography>
                        <Typography paragraph>
                            Now you can view your upcoming gigs, pending requests, and booking history all in one place.
                        </Typography>
                        <Typography paragraph>
                            The <strong>Today's Gigs</strong> widget now includes a button to get directions to your gig, making it easier than ever to navigate to your next performance.
                        </Typography>
                        <Typography>
                            Everything you need to manage your performances is right here.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="contained" onClick={this.props.onDismiss}>
                        Got it!
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default MyScheduleAnnouncementModal;
